import React from "react";
import useSEO from "./useSEO";

const ProjectFundingBusinessLoans = () => {

  useSEO({
    title: "Project Funding & Business Loans | Finance for Startups and SMEs",
    description:
      "Get project funding and business loans to start, expand, or scale your company. Flexible funding solutions for startups, SMEs, and growing businesses.",
    keywords:
      "project funding, business loans, startup business loan, SME funding India, business expansion finance, small business funding, project finance loan, working capital loan",
    ogTitle: "Project Funding & Business Loans for Growing Businesses",
    ogDescription:
      "Secure funding for new projects, infrastructure, equipment, and business expansion with flexible loan options.",
    ogImage: "img/business-loans.png",
    twitterTitle: "Project Funding and Business Loans",
    twitterDescription:
      "Flexible project funding and business loan solutions for startups and enterprises.",
    twitterImage: "img/business-loans.png",
  });

  return (
    <div>

      {/* HERO SECTION */}
      <section className="pt-lg-8 pt-xl-9">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-md-7 col-xl-6 mb-4">
              <h1 className="mb-4">Project Funding & Business Loans</h1>

              <p className="mb-4">
                Project funding and business loans help entrepreneurs,
                startups, and established companies secure the capital needed
                to launch new projects, expand operations, purchase equipment,
                or improve infrastructure. These financing solutions provide
                businesses with the financial support required to achieve
                long-term growth and stability.
              </p>

              <p>
                Whether you are starting a new venture, expanding your
                operations, or investing in technology, business loans provide
                flexible funding options with competitive interest rates and
                convenient repayment plans.
              </p>
            </div>

            <div className="col-md-5 text-center">
              <img
                src="img/project-funding-and-business-loans.jpg"
                alt="Project Funding and Business Loans"
                className="img-fluid"
              />
            </div>

          </div>
        </div>
      </section>

      {/* BENEFITS SECTION */}
      <section className="overflow-hidden pb-5">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-lg-6 mb-4">
              <img
                src="img/project-funding-and-business-loans-.jpg"
                alt="Business Loan Support"
                className="img-fluid"
              />
            </div>

            <div className="col-lg-6">

              <h2 className="mb-4">Key Benefits of Project Funding</h2>
              <hr className="my-4" />

              <ul className="list-group list-group-borderless">

                <li className="list-group-item">
                  <b>Funding for New Projects</b>
                  <p>
                    Get financial support to start new business projects,
                    product launches, or infrastructure development.
                  </p>
                </li>

                <li className="list-group-item">
                  <b>Business Expansion</b>
                  <p>
                    Expand operations, open new branches, upgrade technology,
                    or increase production capacity.
                  </p>
                </li>

                <li className="list-group-item">
                  <b>Flexible Loan Options</b>
                  <p>
                    Choose repayment plans designed to match your business
                    cash flow and project timeline.
                  </p>
                </li>

                <li className="list-group-item">
                  <b>Support for Startups & SMEs</b>
                  <p>
                    Financial solutions available for small businesses,
                    entrepreneurs, and growing enterprises.
                  </p>
                </li>

                <li className="list-group-item">
                  <b>Fast Approval Process</b>
                  <p>
                    Simple documentation and quicker approvals help businesses
                    access funds when they need them the most.
                  </p>
                </li>

              </ul>

            </div>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE */}
      <section className="pb-5 bg-light">
        <div className="container">

          <div className="text-center mb-5">
            <h2>Why Choose Business Loans for Project Funding?</h2>
            <p>
              Project funding allows businesses to grow without exhausting
              internal resources. With the right financial support, companies
              can invest in innovation, scale operations, and stay competitive
              in the market.
            </p>
          </div>

          <div className="row text-center">

            <div className="col-md-4 mb-4">
              <h5>Startup Friendly</h5>
              <p>Funding solutions designed for new entrepreneurs.</p>
            </div>

            <div className="col-md-4 mb-4">
              <h5>Business Growth</h5>
              <p>Access capital to expand and scale faster.</p>
            </div>

            <div className="col-md-4 mb-4">
              <h5>Flexible Repayment</h5>
              <p>Convenient repayment plans based on revenue.</p>
            </div>

          </div>

        </div>
      </section>

    </div>
  );
};

export default ProjectFundingBusinessLoans;